import { useCallback } from "react";

import useUsers from "@/hooks/useUsers";
import useAccountMetadata from "@/hooks/useAccountMetadata";
import { allDestinationsData } from "@/destinations/destinations";
import { zendeskSupportLink } from "@/support/zendeskSupportLink";

export function useCreateZendeskSupportLink() {
  const { loading, currentUser } = useUsers();
  const accountMetadata = useAccountMetadata();

  return useCallback(
    (entitlement: string) => {
      const destinationName = ((): string => {
        if (entitlement in allDestinationsData) {
          return allDestinationsData[entitlement].name;
        }

        return entitlement;
      })();

      const supportMessage = `Hi there! I'm interested in enabling the ${destinationName} destination. My account ID is ${accountMetadata.projects[0].accountID}. Can you help me get this destination set up in my account?`;

      if (loading || currentUser === undefined) {
        return zendeskSupportLink(
          "",
          `Help setting up ${destinationName}`,
          supportMessage,
        );
      }

      return zendeskSupportLink(
        currentUser.email,
        `Help setting up ${destinationName}`,
        supportMessage,
      );
    },
    [accountMetadata, currentUser, loading],
  );
}
